import { useCallback } from 'react'

import { useDatasheetStore } from '@/shared/lib/datasheet/store'

export const useBackupPreset = () => {
	const datasheetStore = useDatasheetStore()
	const handleBackupPreset = useCallback(() => {
		const {
			backupPreset,
			setBackupPreset,
			columnVisibility,
			columnPinning,
			columnOrder,
			columnSizing,
		} = datasheetStore.getState()

		if (!backupPreset) {
			setBackupPreset({
				columnVisibility,
				columnPinning,
				columnOrder,
				columnSizing,
			})
		}
	}, [datasheetStore])

	const handleLoadBackupPreset = useCallback(() => {
		const { backupPreset, setBackupPreset } = datasheetStore.getState()

		if (backupPreset) {
			const { columnVisibility, columnPinning, columnOrder, columnSizing } =
				backupPreset
			datasheetStore.setState({
				columnVisibility,
				columnPinning,
				columnOrder,
				columnSizing,
			})
			setBackupPreset(undefined)
		}
	}, [datasheetStore])
	const handleLoadDefaultPreset = useCallback(() => {
		const { defaultPreset } = datasheetStore.getState()
		datasheetStore.setState({
			columnVisibility: defaultPreset.columnVisibility,
			columnPinning: defaultPreset.columnPinning,
			columnOrder: defaultPreset.columnOrder,
			columnSizing: defaultPreset.columnSizing,
		})
	}, [datasheetStore])

	return {
		handleBackupPreset,
		handleLoadBackupPreset,
		handleLoadDefaultPreset,
	}
}
